import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppInjector } from './app/app-injector.service';

import pkg from '../package.json';

const env = environment.production ? 'prod' : 'dev';
// iOS Cordova WebView uses ionic://; browser builds use http(s)://
const platform = document.URL.startsWith('ionic://') ? 'ios' : 'web';

if (env === 'prod') {
  Sentry.init({
    dsn: 'https://1ca59a849f3246b69f514550ce611a16@o447922.ingest.sentry.io/5658763',
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ['/^//'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    release: `v${pkg.version}`,
    dist: platform,
    tracesSampleRate: 1.0,
    environment: env,
    denyUrls: [/^stripe\.com/i],
    ignoreErrors: [
      /Request timed out\. The device maybe offline/,
      /ConnectionToken has expired/,
      /Printer not connected/,
      /Fail to Open Port/,
      /The device is offline/,
      /TypeError: Load failed/,
      /Network timed out!/,
      /Indexed Database server/,
      /Action canceled/,
      /Could not communicate with the Reader/,
      /cancelCollectPaymentMethod/,
      /reading ['"]isProxied['"]/,
    ],
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(moduleRef => {
    AppInjector.setInjector(moduleRef.injector);
  })
  .catch(err => console.log(err));
